'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.DemandPosting.Toolbar', dependencies).directive('rmDemandPostingToolbar', require('./directives/DemandPostingToolbarDirective'));